<div class="container">
  @let table = data?.tableInstance;
  @if (table) {
    <div class="heading">
      <h5>Filters</h5>
      <div class="toggle">
        <span (click)="table.toggleAllGroups()">{{ (!table.filtersActive ? "TABLE.FILTERS.TURN_ALL_OFF" : "TABLE.FILTERS.TURN_ALL_ON") | translate }}</span>
      </div>
    </div>

    @for (level of table.filters; track $index) {
      <span class="filtergroup">
        <mat-checkbox
          (change)="table.toggleFilterGroup(level.level, $event.checked, level.filters)"
          [indeterminate]="table.filterGroupIndeterminate(level.filters)"
          [checked]="table.filterGroupActive(level.filters)"
        >
          <span [innerHTML]="level.filters.length ? level.filters[0].leveldesc : ''"></span>
        </mat-checkbox>
        <span class="amount">({{ levelcounts[level.level] || "0" }})</span>
      </span>

      @for (option of level.filters; track $index) {
        <span class="filter">
          <mat-checkbox (change)="table.toggleFilterIndividual(level.level, option, $event.checked)" [checked]="table.filterActive(option)">
            <span [innerHTML]="option.value"></span>
          </mat-checkbox>
          <span class="amount">({{ filtercounts[level.level + "|" + option.value] || "0" }})</span>
        </span>
      }
    }
  }
</div>
